import { isEmpty, find, map, mapKeys, camelCase} from 'lodash'
const initialState = {
    //isFetchingFL342Data: false,
    isFetchingPostData: false,
    isFetchingPetitionerReceice: false,
    isFetchingDeptsPet: false,
    isFetchingEqualization: false,
    isFetchingTransferRetirement: false,
    isFetchingSpousalSupport: false,
    isFetchingPrentingPlan: false,
    isFetchingRegularSchedule: false,
    isFetchingHolidaySchedule: false,
    isFetchingSummerSchedule: false,
    isFetchingGetData:false,


    generalProvisionsPetitioner: {
        val: []
    },
    generalProvisionsRespondent: {
        val: []
    },
    otherAssetPetitioner: [],
    otherAssetRespondent: [],
    provisionsPetitioner: {
        val: []
    },
    provisionsRespondent: {
        val: []
    },
    debtsPetitioner: {
        val: []
    },
    assetRespondent: {
        val: []
    },
    addtionLanguage: {
        val: []
    },
    oweEqualizationPayment: {
        val: ""
    },
    owesPayment: {
        val: ""
    },
    spouseOwe: {
        val: ""
    },
    paymentDue: {
        amount:'',
        date:"",
        val: ""
    },
    interestAccrue: {
        amount: '',
        val: ""
    },
    transferRetirement: {
        amount: ''
    },
    requireQdro: {
        amount: ''
    },
    spousalRespondent: {
        amount: '',
        permanent:"",
        date:"",
    },
    spouseShall: {
    amount:'',
    date:"",
},
    reservation: {
        amount: '',
        date:"",
    },
    spousalPetitioner: {
        amount: '',
        permanent:"",
        date:"",
    },
    spousalShall: {
        amount: '',
        date:"",
    },
    resReservation: {
        amount: '',
        date:"",
    },
    minorChildren: {
        amount: ''
    },
    childData: [],

    regularSchedule: {
        amount:'',
        date:"",
        time:"",
        val:"",
        day:[]
    },
    commencingDate: {
        date: ""
    },
    petitionalShall: {
        val: "Petitioner shall have the right to physical custody every Monday from start of school or 8:30 a.m. when school is not in session to Wednesday drop off to school or 8:30 a.m. when school is not in session"
    },
    respondentShall: {
        val: "Respondent Shall have the right to physical custody every Wednesday from start of school or 8:30 a.m. when school is not in session to Friday drop off at school or 8:30 a.m. when school is not in session"
    },
    partiesShall: {
        val: "The parties shall alternate weekends with one parent having the children from Friday start of school or 8:30 a.m. when school is not in session to Monday morning return to school or 8:30 a.m. when school is not in session"
    },
    custodyShall: {
        val: "The custodial parent shall be responsible for returning the child either to school when school is in session or to the residence of the non-custodial parent (receiving parent), when school is not in session"
    },
    parentShall: {
        val: "The parents shall remain flexible with one another to make adjustments to the schedule as needed, and in their children’s best interests"
    },
    scheduleDate: {
        date: ""
    },
    weekPetitionalShall: {
        val: " Week One: Petitioner shall have physical custody of the children every Monday from the start of school or 8:30 a.m. through Wednesday morning return to school or at 8:30 a.m. Respondent shall have physical custody of the children every Wednesday from the start of school or 8:30 a.m. through Friday morning return to school or at 8:30 a.m."
    },
    weekRespondentShall: {
        val: " Week Two: Respondent shall have physical custody of the children every Monday from the start of school or 8:30 a.m. through Wednesday morning return to school or at 8:30 a.m.  Petitioner shall have physical custody of the children every Wednesday from the start of school or 8:30 a.m. through Friday morning return to school or at 8:30 a.m."
    },
    alternateMonday: {
        val: "The parties shall continue to alternate Monday/Tuesday and Wednesday/Thursday"
    },
    alternateWeekend: {
        val: "The parties shall alternate weekends so that the parent who did not have physical custody of the children on the preceding Thursday (day before), shall have physical custody of the children from Friday morning at the start of school or 8:30 a.m., until Monday morning at the start of school or 8:30 a.m"
    },
    remainFlexible: {
        val: "The parties shall remain flexible with one another to make adjustments to the schedule as needed, and in their children’s best interests"
    },
    regularOther: {
        val: ""
    },
    holidaySchedule: {
        amount:'',
        val:"",
    },
    summerSchedule: {
        amount: '',
        summer:"",
        consecutive:"",
        other:"",

    },
 
  
   
}

const MaritalSettlement = (state = initialState, action) => {
    switch (action.type) {
        //POST
        case "REQUEST_POST_DATA":
            return { ...state, isFetchingPostData: true };
        case "SUCCESS_POST_DATA":
            return { ...state, isFetchingPostData: false };
        case "ERROR_POST_DATA":
            return { ...state, isFetchingPostData: false };

        //1#
        case "REQUEST_FORM_MSA_PETITIONER_RECEICE":
            return { ...state, isFetchingPetitionerReceice: true };
        case "SUCCESS_FORM_MSA_PETITIONER_RECEICE":
            return {
                ...state, isFetchingPetitionerReceice: false,
                generalProvisionsPetitioner: {
                    val: action.payload.generalProvisionsPetitioner
                },
                generalProvisionsRespondent: {
                    val: action.payload.generalProvisionsRespondent
                },
                otherAssetPetitioner: action.payload.otherAssetPetitioner,
                otherAssetRespondent:action.payload.otherAssetRespondent,
            };
        case "ERROR_FORM_MSA_PETITIONER_RECEICE":
            return { ...state, isFetchingPetitionerReceice: false };

        //2#
        case "REQUEST_FORM_MSA_DIVIOSION_DEBTS":
            return { ...state, isFetchingDeptsPet: true };
        case "SUCCESS_FORM_MSA_DIVIOSION_DEBTS":
            return {
                ...state, isFetchingDeptsPet: false,
                provisionsPetitioner: {
                    val: action.payload.provisionsPetitioner
                },
                provisionsRespondent: {
                    val: action.payload.provisionsRespondent
                },
                debtsPetitioner: {
                    val: action.payload.debtsPetitioner
                },
                assetRespondent: {
                    val: action.payload.assetRespondent
                },
                addtionLanguage: {
                    val: action.payload.addtionLanguage
                }
            };
        case "ERROR_FORM_MSA_DIVIOSION_DEBTS":
            return { ...state, isFetchingDeptsPet: false };

        //3#
        case "REQUEST_FORM_MSA_EQUALIZATION_PAYMENT":
            return { ...state, isFetchingEqualization: true };
        case "SUCCESS_FORM_MSA_EQUALIZATION_PAYMENT":
            return {
                ...state, isFetchingEqualization: false,
                oweEqualizationPayment: {
                    val: action.payload.oweEqualizationPayment
                },
                owesPayment: {
                    val: action.payload.owesPayment
                },
                spouseOwe: {
                    val: action.payload.spouseOwe
                },
                paymentDue: {
                    amount: action.payload.paymentDue,
                    date: action.payload.paymentDueDate,
                    val: action.payload.paymentPlan,
                },
                interestAccrue: {
                    amount: action.payload.interestAccrue,
                    val: action.payload.accruePerAnnum,
                },

            };
        case "ERROR_FORM_MSA_EQUALIZATION_PAYMENT":
            return { ...state, isFetchingEqualization: false };

        //4#
        case "REQUEST_FORM_MSA_TRANSFER_RETIREMENT":
            return { ...state, isFetchingTransferRetirement: true };
        case "SUCCESS_FORM_MSA_TRANSFER_RETIREMENT":
            return {
                ...state, isFetchingTransferRetirement: false,
                transferRetirement: {
                    amount: action.payload.transferRetirement
                },
                requireQdro: {
                    amount: action.payload.requireQdro
                },
            };
        case "ERROR_FORM_MSA_TRANSFER_RETIREMENT":
            return { ...state, isFetchingTransferRetirement: false };

            //5#
        case "REQUEST_FORM_MSA_PARENTING_PLAN":
            return { ...state, isFetchingPrentingPlan: true };
        case "SUCCESS_FORM_MSA_PARENTING_PLAN":
            return {
                ...state, isFetchingPrentingPlan: false,
                minorChildren: {
                    amount: action.payload.minorChildren
                },
                childData: action.payload.childData

            };
        case "ERROR_FORM_MSA_PARENTING_PLAN":
            return { ...state, isFetchingPrentingPlan: false };

              //6#
        case "REQUEST_FORM_MSA_REGULAR_SCHEDULE":
            return { ...state, isFetchingRegularSchedule: true };
        case "SUCCESS_FORM_MSA_REGULAR_SCHEDULE":
            return {
                ...state, isFetchingRegularSchedule: false,
                regularSchedule: {
                    amount: Number(action.payload.regularSchedule),
                    date: action.payload.weakOffDate,
                    time: action.payload.weakOffTime,
                    val: action.payload.partyExchange,
                    day: action.payload.weakOfDay,
                },
                commencingDate: {
                    date: action.payload.commencingDate
                },
                petitionalShall: {
                    val: action.payload.petitionalShall
                },
                respondentShall: {
                    val: action.payload.respondentShall
                },
                partiesShall: {
                    val: action.payload.partiesShall
                },
                custodyShall: {
                    val: action.payload.custodyShall
                },
                parentShall: {
                    val: action.payload.parentShall
                },
                scheduleDate : {
                    date: action.payload.scheduleDate
                },
                weekPetitionalShall : {
                    val: action.payload.weekPetitionalShall
                },
                weekRespondentShall : {
                    val: action.payload.weekRespondentShall
                },
                alternateMonday : {
                    val: action.payload.alternateMonday
                },
                alternateWeekend : {
                    val: action.payload.alternateWeekend
                },
                remainFlexible : {
                    val: action.payload.remainFlexible
                },
                regularOther: {
                    val: action.payload.regularOther
                },
            };
        case "ERROR_FORM_MSA_REGULAR_SCHEDULE":
            return { ...state, isFetchingRegularSchedule: false };

                 //7#
        case "REQUEST_FORM_MSA_HOLIDAY_SCHEDULE":
            return { ...state, isFetchingHolidaySchedule: true };
        case "SUCCESS_FORM_MSA_HOLIDAY_SCHEDULE":
            return {
                ...state, isFetchingHolidaySchedule: false,
                holidaySchedule: {
                    amount: Number(action.payload.holidaySchedule),
                    val: action.payload.holidayScheduleOther
                },
            };
        case "ERROR_FORM_MSA_HOLIDAY_SCHEDULE":
            return { ...state, isFetchingHolidaySchedule: false };

        //8#
        case "REQUEST_FORM_MSA_SUMMER_SCHEDULE":
            return { ...state, isFetchingSummerSchedule: true };
        case "SUCCESS_FORM_MSA_SUMMER_SCHEDULE":
            return {
                ...state, isFetchingSummerSchedule: false,
                summerSchedule: {
                    amount: Number(action.payload.summerSchedule),
                    summer: action.payload.summerVacationDays,
                    consecutive: action.payload.consecutiveDays,
                    other: action.payload.summerScheduleOther,
                },
                
            };
        case "ERROR_FORM_MSA_SUMMER_SCHEDULE":
            return { ...state, isFetchingSummerSchedule: false };

        //10#
        case "REQUEST_FORM_MSA_SPOUSAL_SUPPORT":
            return { ...state, isFetchingSpousalSupport: true };
        case "SUCCESS_FORM_MSA_SPOUSAL_SUPPORT":
            return {
                ...state, isFetchingSpousalSupport: false,
                spousalRespondent: {
                    amount: action.payload.spousalRespondent,
                    permanent: action.payload.permanentSpousal,
                    date: action.payload.beginDate,
                },
                spouseShall: {
                    amount: action.payload.spouseShall,
                    date: action.payload.terminateDate,
                },
                reservation: {
                    amount: action.payload.reservation,
                    date: action.payload.reservationDate
                },
                spousalPetitioner: {
                    amount: action.payload.spousalPetitioner,
                    permanent: action.payload.spousalSupport,
                    date: action.payload.resbeginDate,
                },
                spousalShall: {
                    amount: action.payload.spousalShall,
                    date: action.payload.resterminateDate
                },
                resReservation: {
                    amount: action.payload.resReservation,
                    date: action.payload.resReservationDate
                },
            };
        case "ERROR_FORM_MSA_SPOUSAL_SUPPORT":
            return { ...state, isFetchingSpousalSupport: false };

          //GET ALL#
        case "REQUEST_MSA_MARITAL_SETTLEMENT_GET_ALL_DATA":
            return { ...state, isFetchingGetData: true };
        case "SUCCESS_MSA_MARITAL_SETTLEMENT_GET_ALL_DATA":
            return {
                 ...state, 
                 generalProvisionsPetitioner: action.payload.generalProvisionsPetitioner,
                 generalProvisionsRespondent: action.payload.generalProvisionsRespondent,
                 otherAssetPetitioner: action.payload.otherAssetPetitioner,
                 otherAssetRespondent: action.payload.otherAssetRespondent,
                 provisionsPetitioner: action.payload.provisionsPetitioner,
                 provisionsRespondent: action.payload.provisionsRespondent,
                 debtsPetitioner: action.payload.debtsPetitioner,
                 assetRespondent: action.payload.assetRespondent,
                 addtionLanguage: action.payload.addtionLanguage,
                 oweEqualizationPayment: action.payload.oweEqualizationPayment,
                 owesPayment: action.payload.owesPayment,
                 spouseOwe: action.payload.spouseOwe,
                paymentDue: action.payload.paymentDue,
                interestAccrue:action.payload.interestAccrue,
                transferRetirement:action.payload.transferRetirement,
                requireQdro:action.payload.requireQdro,
                spousalRespondent:action.payload.spousalRespondent,
                spouseShall:action.payload.spouseShall,
                reservation:action.payload.reservation,
                spousalPetitioner:action.payload.spousalPetitioner,
                spousalShall:action.payload.spousalShall,
                resReservation:action.payload.resReservation,
                minorChildren:action.payload.minorChildren,
                childData: map(action.payload.childData, v => {
                    return mapKeys(v, function(value, key) {
                       return  key === 'divorce_id' ? key : camelCase(key)
                      })
                }),
                regularSchedule:action.payload.regularSchedule,
                commencingDate:action.payload.commencingDate,
                petitionalShall:action.payload.petitionalShall,
                respondentShall:action.payload.respondentShall,
                partiesShall:action.payload.partiesShall,
                custodyShall:action.payload.custodyShall,
                parentShall:action.payload.parentShall,
                scheduleDate:action.payload.scheduleDate,
                weekPetitionalShall:action.payload.weekPetitionalShall,
                weekRespondentShall:action.payload.weekRespondentShall,
                alternateMonday:action.payload.alternateMonday,
                alternateWeekend:action.payload.alternateWeekend,
                remainFlexible:action.payload.remainFlexible,
                regularOther:action.payload.regularOther,
                holidaySchedule:action.payload.holidaySchedule,
                summerSchedule:action.payload.summerSchedule,      
                marriageDate:action.payload.marriage_date,
                seprationDate:action.payload.sepration_date,       
                isFetchingGetData: false
              
             };
        case "ERROR_MSA_MARITAL_SETTLEMENT_GET_ALL_DATA":
            return { ...state, isFetchingGetData: false };

        default:
            return state;
    }
}
export default MaritalSettlement;